import { render, staticRenderFns } from "./IndicatorForm.vue?vue&type=template&id=b6f37f0e&scoped=true&"
import script from "./IndicatorForm.vue?vue&type=script&lang=js&"
export * from "./IndicatorForm.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./IndicatorForm.vue?vue&type=style&index=1&id=b6f37f0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f37f0e",
  null
  
)

export default component.exports